import SimpleBar from 'simplebar';

export default class CustomScrollBar {
  constructor(el) {
    this.el = el
  }

  init() {
    if (window.innerWidth < 1024) {
      return;
    }

    new SimpleBar(this.el, {
      autoHide: false,
    })
  }
}

$('.js-custom-scroll').each((_index, el) => {
  new CustomScrollBar(el).init()
})
